import "../constants-RT-_BdF-.mjs";
import "@smart/types";
import "../index-xuotMAFm.mjs";
import { g as b } from "../helpers-BfS4Sl3r.mjs";
import "../validate-feature-flags-config-Dey5OQSF.mjs";
import "../index-FzzLJwwa.mjs";
import "../index-C-My4wxZ.mjs";
import "../index-DhidOF4D.mjs";
import "@smart/configs";
function M({
  propertyLabelConfig: c,
  marketId: r,
  priceType: m
}) {
  var i, e;
  return ((i = c == null ? void 0 : c[r]) == null ? void 0 : i[m]) || ((e = c == null ? void 0 : c.DEFAULT) == null ? void 0 : e[m]);
}
const z = ({
  marketId: c,
  labels: r,
  paymentType: m,
  priceType: i
}) => {
  const {
    accordionLabelCashBuy: e,
    accordionLabelLeasing: n,
    accordionLabelLeasingSME: d,
    deliveryGroupTotalTaxFormatted: U,
    excludeVatLabel: o,
    headlineCaptionExcludesTaxLabel: s,
    headlineCaptionIncludesTaxLabel: p,
    includesVatLabel: a,
    includesVatOfLabel: u,
    leasingContractFinalizationTxt: L,
    leasingContractFinalizationTxtSME: D,
    leasingPaymentLabel: v,
    leasingPaymentLabelSME: S,
    pcpLeasingPaymentLabel: F,
    accessoryInclVatLabel: l,
    accessoryExclVatLabel: x
  } = r, P = c.toUpperCase(), t = `${u} ${U}`, T = {
    CASHBUY: {
      vatLabel: {
        AT: {
          private: a,
          commercial: a
        },
        FR: {
          private: a,
          commercial: a
        },
        SE: {
          private: a,
          commercial: a
        },
        DEFAULT: {
          private: a,
          commercial: o
        }
      },
      voucherVatLabel: {
        AT: {
          private: a,
          commercial: a
        },
        FR: {
          private: a,
          commercial: a
        },
        SE: {
          private: a,
          commercial: a
        },
        DEFAULT: {
          private: a,
          commercial: o
        }
      },
      vatOfLabel: {
        AT: {
          private: a,
          commercial: a
        },
        FR: {
          private: t,
          commercial: t
        },
        SE: {
          private: t,
          commercial: t
        },
        DEFAULT: {
          private: t,
          commercial: o
        }
      },
      accordionLabel: {
        DEFAULT: {
          private: e,
          commercial: e
        }
      },
      headlineCaptionTaxLabel: {
        SE: {
          private: p,
          commercial: p
        },
        DEFAULT: {
          private: p,
          commercial: s
        }
      },
      accessoryVatLabel: {
        AT: {
          private: l,
          commercial: l
        },
        FR: {
          private: l,
          commercial: l
        },
        SE: {
          private: l,
          commercial: l
        },
        DEFAULT: {
          private: l,
          commercial: x
        }
      }
    },
    LEASING: {
      vatLabel: {
        AT: {
          private: a,
          commercial: a
        },
        FR: {
          private: a,
          commercial: a
        },
        DEFAULT: {
          private: a,
          commercial: o
        }
      },
      paymentLabel: {
        AT: {
          private: v,
          commercial: S
        },
        DEFAULT: {
          private: v,
          commercial: v
        }
      },
      contractFinalizationStepperLabel: {
        AT: {
          private: L,
          commercial: D
        },
        DEFAULT: {
          private: L,
          commercial: L
        }
      },
      accordionLabel: {
        AT: {
          private: n,
          commercial: d
        },
        DEFAULT: {
          private: n,
          commercial: n
        }
      },
      additionalAccordionLabel: {
        DEFAULT: {
          private: e,
          commercial: e
        }
      },
      vatOfLabel: {
        AT: {
          private: a,
          commercial: a
        },
        BE: {
          private: a,
          commercial: a
        },
        FR: {
          private: t,
          commercial: t
        },
        DEFAULT: {
          private: t,
          commercial: o
        }
      },
      headlineCaptionTaxLabel: {
        DEFAULT: {
          private: p,
          commercial: s
        }
      }
    },
    // NOTE: finance is only applicable for GB (PCP leasing payment type)
    FINANCE: {
      vatLabel: {
        DEFAULT: {
          private: a,
          commercial: o
        }
      },
      paymentLabel: {
        GB: {
          private: F,
          commercial: F
        },
        DEFAULT: {
          private: v,
          commercial: v
        }
      },
      contractFinalizationStepperLabel: {
        DEFAULT: {
          private: L,
          commercial: L
        }
      },
      accordionLabel: {
        DEFAULT: {
          private: n,
          commercial: n
        }
      },
      headlineCaptionTaxLabel: {
        DEFAULT: {
          private: p,
          commercial: s
        }
      }
    }
  }, A = T == null ? void 0 : T[m];
  return b(A).reduce(
    (C, E) => ({
      ...C,
      [E]: M({
        propertyLabelConfig: A[E],
        marketId: P,
        priceType: i
      })
    }),
    {}
  );
};
function G(c, r) {
  return b(r).reduce(
    (i, e) => ({
      ...i,
      [e]: r[e][c] ?? r[e].DEFAULT
    }),
    {}
  );
}
function K({
  marketId: c,
  priceType: r,
  paymentMode: m,
  labels: i
}) {
  const e = c.toUpperCase();
  return e === "GB" && m === "finance" ? i.leasePriceLabelPCP : e === "AT" && r === "commercial" ? i.leasePriceLabelSME : i.leasePriceLabel;
}
export {
  G as getAppMarketConfig,
  z as getLabelsForMarketPriceTypePaymentType,
  K as getLeasingLabelForSpecificMarket
};
//# sourceMappingURL=index.mjs.map
